import ProcessStatusView, { ProcessStatus } from "@/components/ProcessStatusView"
import QueryRunner from "@/services/ad-hoc-query-runner-2";
import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util";
import flywhweelDEUtilFactory from "@/services/flywheel-de-util";
import FolderSelector from "@/components/FolderSelector.vue";
import CountsToolFieldView, { inputDefaultValues as countsToolInputDefaultValues } from './CountsToolField';
import queryTemplate from './QueryTemplate';
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';
import dataExtensionRootFoldersFactory from '@/services/data-extension-root-folders';
import downloadFiles from "@/services/download-files";
import DERowsTable from '@/components/DERowsTable';

var formGroupsConfig = [
    {
        "key": "customSQLWhereEnabled",
        "label": "Use a custom SQL where clause",
        "attrs": {
            "type": "checkbox",
            "true-value": 'true',
            "false-value": 'false'
        }
    },
    {
        "key": "customSQLWhere",
        "label": "Custom SQL where clause",
        "attrs": {
            "type": "textarea"
        },
        "helperText":[
            'Use the alias <code>src</code> to refer to the selected data extension',
            'Omit the <code>where</code>.  Just enter the expression itself.'
        ]
    },
    {
        "key": "showInlineTable",
        "label": "Show results in an HTML table",
        "attrs": {
            "type": "checkbox",
            "true-value": 'true',
            "false-value": 'false'
        }
    },
    {
        "key": "renderRawData",
        "label": "Render raw data",
        "attrs": {
            "type": "checkbox",
            "true-value": 'true',
            "false-value": 'false'
        }
    },
    {
        "key": "delimiter",
        "label": "Delimiter",
        "attrs": {
            "type": "select",
            "required": true
        },
        "options": Object.keys(QueryRunner.delimiters).map((k) => ({
            label: QueryRunner.delimiters[k].label,
            value: k
        }))
    },
    {
        "key": "autoDownloadResults",
        "label": "Download results",
        "attrs": {
            "type": "checkbox",
            "true-value": 'true',
            "false-value": 'false'
        }
    },
    {
        "key": "autoDeleteDE",
        "label": "Auto-delete result data extension",
        "attrs": {
            "type": "checkbox",
            "true-value": 'true',
            "false-value": 'false'
        }
    },
    {
        "key": "deTgtName",
        "label": "Data Extension Name",
        "attrs": {
            "type": "text",
            "required": true,
            "maxlength": 96
        }
    },
    {
        "key": "retentionInDays",
        "label": "Data Extension Retention in Days",
        "attrs": {
            "type": "text",
            "required": true,
            "pattern": "^[1-9][0-9]*$"
        }
    } 
];

var formGroupsResult = [
    {
        "key": "resultRows",
        "label": "Result Rows",
        "attrs": {
            "type": "textarea"
        }
    }
]

export default {
    name: "CountsToolView",
    components: {
        FolderSelector,
        ProcessStatusView,
        CountsToolFieldView,
        FormInputGroupView,
        DERowsTable
    },
    data: function() {
        var data = {
            uiStates: {
                LOADING: 'loading',
                SELECT_DE: 'select-de',
                CHECKING_SELECTED_DE: 'check-selected-de',
                CONFIGURE_COUNTS: 'configure-sampling',
                RUNNING_QUERY: 'running-query',
                RUNNING_QUERY_ERROR: 'running-query-error',
                SAMPLES_COMPLETE: 'samples-complete'
            },
            processStates: {
                CREATING_DE: 'Creating data extension...',
                SAMPLES_COMPLETE: 'Samples data extension is ready.'
            },
            uiState: null,
            rootFolders: [], //this.dataExtensionRootFolders.foldersAvailable,
            rootFolder: null,
            rootFolderSelectorDisabled: true,

            forms: {
                config: {
                    inputs: FormInputGroup.makeInputs(formGroupsConfig),
                    values: FormInputGroup.makeValues(formGroupsConfig, {
                        deTgtName: QueryRunner.makeId('COUNTS'),
                        retentionInDays: '21',
                        showInlineTable: 'true',
                        renderRawData: 'false',
                        delimiter: "tab",
                        autoDeleteDE: 'true',
                        autoDownloadResults: 'false',
                        customSQLWhereEnabled: 'false',
                        customSQLWhere: ''
                    })
                },
                result: {
                    inputs: FormInputGroup.makeInputs(formGroupsResult),
                    values: FormInputGroup.makeValues(formGroupsResult, {})
                }
            },
            
            dataExtensionSrc: null,
            dataExtensionTgtParams: null,
            groupByFields: null,
            /*
            dataExtensionSrc: {
                "CategoryID": "646421",
                "Client": {
                    "ID": "1381905"
                },
                "CreatedDate": "2019-01-31T16:37:21.627",
                "CustomerKey": "27E2E067-5366-48C2-B07C-60D290ED268E",
                "DeleteAtEndOfRetentionPeriod": "false",
                "Description": null,
                "Fields": {
                    "Field": [
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "50",
                            "Name": "FirstName",
                            "Ordinal": "5"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "50",
                            "Name": "LastName",
                            "Ordinal": "6"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "100",
                            "Name": "AddressLine2",
                            "Ordinal": "8"
                        },
                        {
                            "DefaultValue": "getdate()",
                            "FieldType": "Date",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "Name": "Date_Added",
                            "Ordinal": "4"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "5",
                            "Name": "OptinFlag_SeaBags",
                            "Ordinal": "13"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "10",
                            "Name": "ZipCode",
                            "Ordinal": "11"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "EmailAddress",
                            "IsPrimaryKey": "false",
                            "IsRequired": "true",
                            "MaxLength": "254",
                            "Name": "EmailAddress",
                            "Ordinal": "2"
                        },
                        {
                            "DefaultValue": "proof",
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "10",
                            "Name": "recip_type",
                            "Ordinal": "3"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "150",
                            "Name": "AddressLine1",
                            "Ordinal": "7"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "50",
                            "Name": "City",
                            "Ordinal": "9"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "true",
                            "MaxLength": "254",
                            "Name": "SubscriberKey",
                            "Ordinal": "1"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "50",
                            "Name": "State",
                            "Ordinal": "10"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "5",
                            "Name": "OptInFlag_PolandSpring",
                            "Ordinal": "12"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "50",
                            "Name": "Source Code",
                            "Ordinal": "14"
                        }
                    ]
                },
                "IsSendable": "true",
                "IsTestable": "false",
                "ModifiedDate": "2019-01-31T16:37:21.627",
                "Name": "TEST_PH_201923F",
                "ObjectID": "84f104c1-a825-e911-ac10-38eaa7158569",
                "PartnerKey": null,
                "ResetRetentionPeriodOnImport": "false",
                "RetainUntil": null,
                "RowBasedRetention": "false",
                "SendableDataExtensionField": {
                    "Name": "EmailAddress",
                    "ObjectID": null,
                    "PartnerKey": null
                },
                "SendableSubscriberField": {
                    "Name": "_EmailAddress"
                },
                "Status": "None",
                "Template": {
                    "CustomerKey": "26FE5A14-1022-4880-AEFD-C8CA26B844D9",
                    "ObjectID": null,
                    "PartnerKey": null
                }
            },
            dataExtensionTgtParams: {
                "name": "SAMPLES_20200402190828589_50584560",
                "properties": {
                    "CategoryID": "646421",
                    "DeleteAtEndOfRetentionPeriod": "false",
                    "Fields": {
                        "Field": [
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "true",
                                "MaxLength": "254",
                                "Name": "SubscriberKey",
                                "Ordinal": "1"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "EmailAddress",
                                "IsPrimaryKey": "false",
                                "IsRequired": "true",
                                "MaxLength": "254",
                                "Name": "EmailAddress",
                                "Ordinal": "2"
                            },
                            {
                                "DefaultValue": "proof",
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "10",
                                "Name": "recip_type",
                                "Ordinal": "3"
                            },
                            {
                                "DefaultValue": "getdate()",
                                "FieldType": "Date",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "Name": "Date_Added",
                                "Ordinal": "4"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "50",
                                "Name": "FirstName",
                                "Ordinal": "5"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "50",
                                "Name": "LastName",
                                "Ordinal": "6"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "150",
                                "Name": "AddressLine1",
                                "Ordinal": "7"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "100",
                                "Name": "AddressLine2",
                                "Ordinal": "8"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "50",
                                "Name": "City",
                                "Ordinal": "9"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "50",
                                "Name": "State",
                                "Ordinal": "10"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "10",
                                "Name": "ZipCode",
                                "Ordinal": "11"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "5",
                                "Name": "OptInFlag_PolandSpring",
                                "Ordinal": "12"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "5",
                                "Name": "OptinFlag_SeaBags",
                                "Ordinal": "13"
                            },
                            {
                                "DefaultValue": null,
                                "FieldType": "Text",
                                "IsPrimaryKey": "false",
                                "IsRequired": "false",
                                "MaxLength": "50",
                                "Name": "Source Code",
                                "Ordinal": "14"
                            }
                        ]
                    },
                    "IsSendable": "true",
                    "IsTestable": "true",
                    "ResetRetentionPeriodOnImport": "false",
                    "RetainUntil": null,
                    "RowBasedRetention": "false",
                    "SendableDataExtensionField": {
                        "Name": "EmailAddress",
                        "ObjectID": null,
                        "PartnerKey": null
                    },
                    "SendableSubscriberField": {
                        "Name": "Email Address"
                    }
                },
                "sendableFieldName": "EmailAddress",
                "path": "Data Extensions/_Triggered"
            },
            groupByFields: {
                "SubscriberKey": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "true",
                        "MaxLength": "254",
                        "Name": "SubscriberKey",
                        "Ordinal": "1"
                    }
                },
                "recip_type": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": "proof",
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "10",
                        "Name": "recip_type",
                        "Ordinal": "3"
                    }
                },
                "Date_Added": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": "getdate()",
                        "FieldType": "Date",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "Name": "Date_Added",
                        "Ordinal": "4"
                    }
                },
                "FirstName": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "50",
                        "Name": "FirstName",
                        "Ordinal": "5"
                    }
                },
                "LastName": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "50",
                        "Name": "LastName",
                        "Ordinal": "6"
                    }
                },
                "AddressLine1": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "150",
                        "Name": "AddressLine1",
                        "Ordinal": "7"
                    }
                },
                "AddressLine2": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "100",
                        "Name": "AddressLine2",
                        "Ordinal": "8"
                    }
                },
                "City": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "50",
                        "Name": "City",
                        "Ordinal": "9"
                    }
                },
                "State": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "50",
                        "Name": "State",
                        "Ordinal": "10"
                    }
                },
                "ZipCode": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "10",
                        "Name": "ZipCode",
                        "Ordinal": "11"
                    }
                },
                "OptInFlag_PolandSpring": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "5",
                        "Name": "OptInFlag_PolandSpring",
                        "Ordinal": "12"
                    }
                },
                "OptinFlag_SeaBags": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "5",
                        "Name": "OptinFlag_SeaBags",
                        "Ordinal": "13"
                    }
                },
                "Source Code": {
                    "groupBy": 'false',
                    "properties": {
                        "DefaultValue": null,
                        "FieldType": "Text",
                        "IsPrimaryKey": "false",
                        "IsRequired": "false",
                        "MaxLength": "50",
                        "Name": "Source Code",
                        "Ordinal": "14"
                    }
                }
            },
            */
            
            dataExtensionTgtName: '',
            dataExtensionTgtPath: '',

            inlineTable: {
                fields: [],
                rows: []
            },
            processStatus: new ProcessStatus(QueryRunner.STATE_IDLE),
            QueryRunner
        };

        //data.uiState = data.uiStates.CONFIGURE_COUNTS;
        data.uiState = data.uiStates.LOADING;

        data.rootFolder = {};
        
        data.queryRunner = null;
        data.queryRunnerMoreDataAvailable = false;

        return data;
    },
    created: function() {
        this.sfmcDE = flywhweelDEUtilFactory(this);
        this.sfmcFolder = flywhweelSFMCUtilFactory(this, "folder");
        this.dataExtensionRootFolders = dataExtensionRootFoldersFactory(this.$store, this.sfmcFolder);
        this.formConfig = FormInputGroup.util(() => this.forms.config.inputs);
    },
    mounted: function() {
        this.dataExtensionRootFolders.getFoldersAvailable().then(
            (foldersAvailable) => {
                this.rootFolders = foldersAvailable;
                this.rootFolder = this.rootFolders[0];
                this.uiState = this.uiStates.SELECT_DE;
            }
        );
        this.onRenderRawDataChange();
    },
    computed: {
        queryRunnerDisabled: function() {
            return (
                (this.processStatus.state != QueryRunner.STATE_IDLE) &&
                (this.processStatus.state != QueryRunner.STATE_ERROR)
            );
        }
    },
    watch: {
        'forms.config.values.renderRawData': function() {
            this.onRenderRawDataChange();
        },
        'forms.config.values.autoDeleteDE': function() {
            this.onRenderRawDataChange();
        },
        'forms.config.values.customSQLWhereEnabled': function() {
            this.onRenderRawDataChange();
        },
        'forms.config.values.customSQLWhere': function() {
            this.updateWhereClause();
        },
        'rootFolder': function() {
            this.dataExtensionSrc = null;
            this.dataExtensionTgtParams = null;
            this.groupByFields = null;
        }
    },
    methods: {
        setDeTgtName: function() {
            this.forms.config.values.deTgtName = QueryRunner.makeId(
                'COUNTS',
                (this.dataExtensionSrc && this.dataExtensionSrc.Name) ?
                this.dataExtensionSrc.Name :
                ''
            );
        },
        backToSelectDe: function() {
            this.dataExtensionTgtParams = null;
            this.dataExtensionSrc = null;
            this.uiState = this.uiStates.SELECT_DE;
        },
        backToConfigureCounts: function() {
            this.setDeTgtName();
            this.uiState = this.uiStates.CONFIGURE_COUNTS;
        },
        forwardToConfigureCounts: function() {
            if (this.dataExtensionTgtParams !== null) {
                this.setDeTgtName();
                this.uiState = this.uiStates.CONFIGURE_COUNTS;
            }
        },

        folderSelectorState: function(state) {
            if ((state == 'unk') || (state == 'loading')) {
                this.rootFolderSelectorDisabled = true;
            } else {
                this.rootFolderSelectorDisabled = false;
            }
        },

        onRenderRawDataChange: function() {
            if (this.forms.config.values.renderRawData == 'true') {
                this.formConfig.get('delimiter').attrs.disabled = false;
                this.formConfig.get('autoDownloadResults').attrs.disabled = false;
            } else {
                this.forms.config.values.autoDownloadResults = 'false';
                this.formConfig.get('delimiter').attrs.disabled = true;
                this.formConfig.get('autoDownloadResults').attrs.disabled = true;
            }

            if (this.forms.config.values.autoDeleteDE == 'true') {
                this.forms.config.values.retentionInDays = '1';
                this.setDeTgtName();
                this.formConfig.get('retentionInDays').attrs.disabled = true;
                this.formConfig.get('deTgtName').attrs.disabled = true;
            } else {
                this.formConfig.get('retentionInDays').attrs.disabled = false;
                this.formConfig.get('deTgtName').attrs.disabled = false;
            }

            if (this.forms.config.values.customSQLWhereEnabled == 'true') {
                this.formConfig.get('customSQLWhere').attrs.disabled = false;
            } else {
                this.forms.config.values.customSQLWhere = '';
                this.formConfig.get('customSQLWhere').attrs.disabled = true;
            }
        },

        formChangeConfig: function(event) {
            this.forms.config.values[event.key] = event.value;
        },

        prepDETgtParams: function(data) {
            return this.sfmcFolder.apiCall(
                'retrieve_path_from_id',
                {
                    id: data.CategoryID
                }
            ).then(
                (response) => {
                    return Promise.resolve({
                        name: this.forms.config.values.deTgtName,
                        path: response.data
                    });
                }
            );
        },
        deSelected: function(objectType, object, folder) {
            this.uiState = this.uiStates.CHECKING_SELECTED_DE;
            this.sfmcDE.apiCall(
                "retrieve",
                {
                    "complex_filter": this.sfmcDE.complexFilter(
                        this.sfmcDE.simpleFilter(
                            'CustomerKey',
                            object.CustomerKey
                        ),
                        'AND',
                        this.sfmcDE.simpleFilter(
                            'CategoryID',
                            folder.ID
                        )
                    ),
                    "get_columns": true,
                    "single_result": true,
                    "query_all_accounts": true
                }
            ).then(
                (response) => {
                    this.dataExtensionSrc = JSON.parse(JSON.stringify(response.data));
                    this.setDeTgtName();
                    return this.prepDETgtParams(response.data);
                }
            ).then(
                (params) => {
                    this.dataExtensionTgtParams = params;
                    this.groupByFields = {};

                    if (this.dataExtensionSrc) {
                        this.dataExtensionSrc.Fields.Field.forEach((field) => {
                            this.groupByFields[field.Name] = {
                                properties: field,
                                values: JSON.parse(JSON.stringify(countsToolInputDefaultValues))
                            }
                        });
                    }

                    this.uiState = this.uiStates.SELECT_DE;
                }
            );
            //console.log(JSON.stringify(arguments, null, 2));
        },
        
        updateWhereClause: function() {
            var newValue = this.forms.config.values.customSQLWhere.replace(/^\s+/, '');
            //console.log(
            //    newValue,
            //    newValue.substr(0, 'where'.length + 1).toLowerCase(),
            //    newValue.substr(0, 'where'.length + 1).toLowerCase().match(/where\s/)
            //);
            if (newValue.substr(0, 'where'.length + 1).toLowerCase().match(/where\s/)) {
                this.forms.config.values.customSQLWhere = newValue.substr('where'.length + 1);
            }
        },

        updateField: function(fieldKey, formValues) {
            var field = this.groupByFields[fieldKey];
            field.values = formValues;
        },

        makeQueryTemplateContext: function() {
            var context = {
                deSourceName: this.sfmcDE.normalizeDEName(
                    ((this.$store.getters.bu.isChild && this.rootFolder.ent) ? 'ent.' : '') +
                    this.dataExtensionSrc.Name
                ),
                groupByList: []
            };
            Object.keys(this.groupByFields).forEach((k) => {
                var field = JSON.parse(JSON.stringify(this.groupByFields[k]));
                field.groupBy = field.values.groupBy == 'true';
                field.fieldNameAliased = `src.[${field.properties.Name}]`;
                field.sqlExpression = field.fieldNameAliased;
                if (field.values.customSQLExpressionEnabled == 'true') {
                    field.sqlExpression = `(${field.values.customSQLExpression})`;
                } else if (field.properties.FieldType == 'EmailAddress') {
                    if (field.values.groupByDomain == 'true') {
                        field.sqlExpression = (
                            `substring(${field.sqlExpression}, charindex('@', ${field.sqlExpression}) + 1, len(${field.sqlExpression}))`
                        );
                    }
                } else if (field.properties.FieldType == 'Date') {
                    if (field.values.groupByFormatDate) {
                        if (field.values.groupByFormatDate == 'datediff-month') {
                            field.sqlExpression = (
                                `datediff(month, ${field.sqlExpression}, getdate())`
                            );
                        } else if (field.values.groupByFormatDate == 'datediff-quarter') {
                            field.sqlExpression = (
                                `datediff(quarter, ${field.sqlExpression}, getdate())`
                            );
                        } else {
                            field.sqlExpression = (
                                `format(${field.sqlExpression}, '${field.values.groupByFormatDate}')`
                            );
                        }
                    }
                } else if (field.properties.FieldType == 'Decimal') {
                    if (field.values.roundDecimal == 'true') {
                        field.sqlExpression = (
                            `round(${field.sqlExpression}, ${field.values.decimalPlacesDecimal})`
                        );
                    }
                }

                if (field.groupBy) {
                    context.groupByList.push({
                        ...field,
                        ...{
                            name: field.properties.Name
                        }
                    });
                }
            });

            if (this.forms.config.values.customSQLWhereEnabled == 'true') {
                context.customWhereClause = this.forms.config.values.customSQLWhere;
            }
            return context;
        },

        createSamples: function() {
            var delimiter;
            var context = this.makeQueryTemplateContext();

            if (context.groupByList.length == 0) {
                alert('Please choose at least on field on which to group.');
                return Promise.resolve();
            }

            this.processStatus.reset();
            this.processStatus.state = this.processStates.CREATING_DE;
            this.uiState = this.uiStates.RUNNING_QUERY;

            this.dataExtensionTgtParams.name = this.forms.config.values.deTgtName;

            delimiter = QueryRunner.delimiters[this.forms.config.values.delimiter]

            var queryRunner = new QueryRunner(
                this,
                queryTemplate(context),
                {
                    tgtDEPath: (
                        this.rootFolder.canCreateDE ?
                        this.dataExtensionTgtParams.path :
                        QueryRunner.tgtDEPathDefault
                    ),
                    tgtDEName: this.dataExtensionTgtParams.name,
                    responseRender: (
                        (this.forms.config.values.renderRawData == 'true') ?
                        QueryRunner.RESPONSE_RENDER :
                        QueryRunner.RESPONSE_IGNORE
                    ),
                    retrieveResultObject: (
                        this.forms.config.values.showInlineTable == 'true'
                    ),
                    autoDeleteDE: (
                        this.forms.config.values.autoDeleteDE == 'true'
                    ),
                    dataRetention: {
                        DataRetentionPeriod: "Days",
                        DataRetentionPeriodLength: String(this.forms.config.values.retentionInDays),
                        DeleteAtEndOfRetentionPeriod: "false"
                    },
                    delimiter: delimiter
                },
                this.processStatus
            );
            return queryRunner.run().then(
                (resultRows) => {
                    this.forms.result.values.resultRows = resultRows;

                    this.dataExtensionTgtName = queryRunner.options.tgtDEName;
                    this.dataExtensionTgtPath = queryRunner.options.tgtDEPath;
        
                    if (queryRunner.queryResultMoreDataAvailable) {
                        this.queryRunnerMoreDataAvailable = true;
                    }
                    if (this.forms.config.values.showInlineTable == 'true') {
                        this.inlineTable.rows = queryRunner.queryResultObject;
                        this.inlineTable.fields = queryRunner.tgtDEFieldProperties;
                    }
                    if (this.forms.config.values.autoDownloadResults == 'true') {
                        var delimiter = QueryRunner.delimiters[this.forms.config.values.delimiter];
                        return downloadFiles(
                            [
                                {
                                    name: `${this.forms.config.values.deTgtName}.${delimiter.extension}`,
                                    content: resultRows,
                                    type: delimiter.mimeType
                                }
                            ], 
                            "DE_Rows.zip"
                        ).then(
                            () => {
                                this.uiState = this.uiStates.SAMPLES_COMPLETE;
                                return Promise.resolve();
                            }
                        );
                    } else {
                        this.uiState = this.uiStates.SAMPLES_COMPLETE;
                        return Promise.resolve();
                    }
                },
                (error) => {
                    //console.error(error);
                    this.processStatus.state = QueryRunner.STATE_ERROR;
                    this.processStatus.error(
                        error.apiResponseMessage,
                        error.apiResponseRaw
                    );
                    this.uiState = this.uiStates.RUNNING_QUERY_ERROR;
                }
            );
        }
    }
}